import { Link } from "react-router-dom";
import RightArrow from "../SVG";
import Image from "../../assets/img/course/course-2-1.jpg";

const style = {
  width: "100%",
  height: "250px",
  objectFit: "cover",
  objectPosition: "top",
};
const SingleCourse = (props) => {
  const {
    itemClass,
    courseImage,
    thumbText,
    title,
    btnText,
    edate,
    content,
    btnClass,
    hasArrow,
    onClick,
    _id,
  } = props;

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleDateString("en-US", { month: "long" });
    const year = date.getFullYear();
    return { day, month, year };
  };

  const formattedDate = formatDate(edate);

  return (
    <div className={itemClass ? itemClass : "it-course-item ed-course-style-2"}>
      <div className="it-course-thumb mb-25 p-relative">
        <Link to={`/event-details?eventId=${_id}&&title=${title}`}>
          <img src={courseImage ? courseImage : Image} alt="" style={style} />
        </Link>
        <div className="it-course-thumb-text">
          <span>{thumbText ? thumbText : "Digital Marketing"}</span>
        </div>
        {edate && (
          <div className="absolute top-4 right-4 bg-gradient-to-br from-purple-500 to-purple-700 text-white rounded-2xl z-10 shadow-lg overflow-hidden">
            <div className="px-3 py-2 text-center">
              <div className="text-lg font-bold leading-none">
                {formattedDate.day}
              </div>
              <div className="text-xs font-medium leading-tight">
                {formattedDate.month}
              </div>
              <div className="text-xs font-medium leading-tight">
                {formattedDate.year}
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="it-course-content p-relative">
        <h4 className="it-course-title pb-15">
          <Link to={`/event-details?eventId=${_id}&&title=${title}`}>
            {title ? title : "It Statistics Data Science And Business Analysis"}
          </Link>
        </h4>
        <p className="it-course-text">{content}</p>
        <div className="d-flex justify-content-end align-items-center">
          <div className="ed-course-price-box">
            <button
              onClick={onClick}
              className={btnClass ? btnClass : "ed-btn-blog"}
            >
              {btnText ? btnText : "read more"}
              {hasArrow && (
                <i>
                  <RightArrow />
                </i>
              )}
            </button>
          </div>
        </div>
        {/* <div className="ed-course-shape">
          <img src={shapeImg} alt="" />
        </div> */}
      </div>
    </div>
  );
};
export default SingleCourse;
